import React from "react";
import { Link } from "react-router-dom";
import { Plane, Mail, MessageCircle, ShieldCheck } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0f1b2d] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-6 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 rounded-md bg-white text-[#0f1b2d] grid place-items-center">
              <Plane className="w-5 h-5" strokeWidth={2.2} />
            </div>
            <div className="font-display font-extrabold tracking-tight text-lg">
              Schengen<span className="text-[#60a5fa]">File</span>
            </div>
          </div>
          <p className="text-sm text-white/70 max-w-md leading-relaxed">
            Complete document packages for your Schengen visa appointment. Real flight reservations with PNR, verifiable hotel bookings, valid insurance certificates.
          </p>
          <div className="flex items-center gap-3 mt-6 text-xs text-white/60">
            <ShieldCheck className="w-4 h-4 text-[#60a5fa]" />
            Secure payments · Refund if not delivered on time
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">Product</div>
          <ul className="space-y-3 text-sm text-white/80">
            <li><a href="/#pricing" className="hover:text-white">Packages</a></li>
            <li><a href="/#how" className="hover:text-white">How it works</a></li>
            <li><a href="/#faq" className="hover:text-white">FAQ</a></li>
            <li><Link to="/apply" className="hover:text-white">Apply now</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">Resources</div>
          <ul className="space-y-3 text-sm text-white/80">
            <li><Link to="/schengen-visa-guide" data-testid="footer-link-guide" className="hover:text-white">Schengen Visa Guide</Link></li>
            <li><Link to="/blog" data-testid="footer-link-blog" className="hover:text-white">Blog</Link></li>
            <li><Link to="/build-your-file" className="hover:text-white">Build your file</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">Support</div>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> support@schengenfile.com</li>
            <li className="flex items-center gap-2"><MessageCircle className="w-4 h-4" /> WhatsApp 24/7</li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">Legal</div>
          <ul className="space-y-3 text-sm text-white/80">
            <li><Link to="/terms" data-testid="footer-link-terms" className="hover:text-white">Terms of Service</Link></li>
            <li><Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/refunds" data-testid="footer-link-refunds" className="hover:text-white">Refund Policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 text-xs text-white/50 flex flex-col md:flex-row items-center justify-between gap-2">
          <div>© {new Date().getFullYear()} SchengenFile. All rights reserved.</div>
          <div>Documents are for visa application support only. We do not guarantee visa approval.</div>
        </div>
      </div>
    </footer>
  );
}
